import * as tslib_1 from "tslib";
import './boxes.less';
import m from 'mithril';
import { cleanupOptions } from '../../util/formutils';
import { Component } from '../component';
import { Checkbox } from './checkbox';
var Boxes = /** @class */ (function (_super) {
    tslib_1.__extends(Boxes, _super);
    function Boxes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = _this.attrs.className || (_this.attrs.unstyled && 'boxes') || 'boxes-front';
        return _this;
    }
    Boxes.prototype.setValue = function (key, active) {
        var _a = this.attrs, _b = _a.value, value = _b === void 0 ? [] : _b, _c = _a.onchange, onchange = _c === void 0 ? function () { } : _c;
        if (active) {
            if (!value.find(function (v) { return v == key; }))
                onchange(value.concat([key]));
            else
                onchange(value);
        }
        else {
            onchange(value.filter(function (v) { return v != key; }));
        }
    };
    Boxes.prototype.view = function () {
        var _this = this;
        var _a = this.attrs, _b = _a.value, value = _b === void 0 ? [] : _b, options = _a.options, unstyled = _a.unstyled, required = _a.required;
        var cleanOptions = cleanupOptions(options);
        var half = Math.ceil(cleanOptions.length / 2);
        return m("div." + this.className, [
            m("div." + this.className + "-left", [
                cleanOptions.slice(0, half).map(function (o) {
                    return m(Checkbox, {
                        unstyled: unstyled,
                        required: required && value.length == 0,
                        value: value.find(function (v) { return v == o.key; }),
                        onchange: function (d) { return _this.setValue(o.key, d); },
                        label: o.label
                    });
                })
            ]),
            m("." + this.className + "-right", [
                cleanOptions.slice(half).map(function (o) {
                    return m(Checkbox, {
                        unstyled: unstyled,
                        required: required && value.length == 0,
                        value: value.find(function (v) { return v == o.key; }),
                        onchange: function (d) { return _this.setValue(o.key, d); },
                        label: o.label
                    });
                })
            ])
        ]);
    };
    return Boxes;
}(Component));
export { Boxes };
